module.exports = __webpack_public_path__ + "static/carFleet-4f3caef175331198134ebdd402a01da4.png";